// extracted by mini-css-extract-plugin
module.exports = {"feedbackSubtitle":"style-module_feedbackSubtitle__fakxUXbvwrW7eDQtDufx"};